/**
 * DashboardShell — shared layout wrapper for all dashboard pages.
 *
 * Props:
 *   title     - dashboard title (e.g. "Student Dashboard")
 *   subtitle  - subtitle text (e.g. user email)
 *   icon      - Lucide icon component
 *   iconBg    - tailwind bg class for icon container (e.g. "bg-blue-600")
 *   onLogout  - logout handler
 *   children  - dashboard body content
 */
import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '../ui/button';

const DashboardShell = ({ title, subtitle, icon: Icon, iconBg = 'bg-blue-600', onLogout, children }) => (
    <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <div className="bg-white border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center space-x-3">
                        <div className={`${iconBg} p-2 rounded-lg`}>
                            {Icon && <Icon className="h-6 w-6 text-white" />}
                        </div>
                        <div>
                            <h1 className="text-xl font-bold text-gray-900">{title}</h1>
                            {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
                        </div>
                    </div>
                    <Button variant="outline" onClick={onLogout}>
                        <LogOut className="h-4 w-4 mr-2" />
                        Logout
                    </Button>
                </div>
            </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {children}
        </div>
    </div>
);

export default DashboardShell;
